<script setup lang="ts">
import { ref } from 'vue';
import { useAuth } from '@/stores/auth';
import BaseButton from '@/components/ui/BaseButton.vue';
import BaseCard from '@/components/ui/BaseCard.vue';

const auth = useAuth();
const loading = ref(false);

async function onSignIn() {
  loading.value = true;
  try {
    await auth.loginBoard();
    // MSAL redirects the browser; control does not return here.
  } finally {
    loading.value = false;
  }
}
</script>

<template>
  <BaseCard padding="lg">
    <h1 class="text-page text-fg mb-2">Sign in</h1>
    <p class="text-body text-muted mb-6">
      HOA Watch board members sign in with Microsoft. Residents use the
      <a href="/resident/login" class="text-navy-700 underline">resident portal</a>.
    </p>
    <BaseButton
      block
      :loading="loading"
      data-testid="signin-button"
      @click="onSignIn"
    >
      <span v-if="loading">Redirecting…</span>
      <span v-else>Sign in with Microsoft</span>
    </BaseButton>
  </BaseCard>
</template>
